import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_SPESE_GENERALI } from '../../data.const';
import {
  retrieveSpeseGeneraliListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteSpeseGeneraliEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_SPESE_GENERALI),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ fatturaLoader: true })),
        defer(() =>
          from(
            request({
              path: `speseGenerali`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveSpeseGeneraliListAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_SPESE_GENERALI}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ fatturaLoader: false }))
      );
    })
  );

export default deleteSpeseGeneraliEpic;
